import { render, staticRenderFns } from "./TeamsCategories.vue?vue&type=template&id=096b7478&"
import script from "./TeamsCategories.vue?vue&type=script&lang=js&"
export * from "./TeamsCategories.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports